import { useUserHasConsignorMasterUI } from 'src/hooks/useUserIsConsignorMasterUI';
import { useContext as useContextWithSelector } from 'use-context-selector';

import {
  catalogMetricsContextWithSelector,
  catalogMetricsEmptyContextWithSelector,
} from './CatalogMetrics.type';

/**
 * @deprecated use the explicit context selectors to avoid unnecessary re-render
 */
export function useCatalogMetricsContext<
  TMetrics extends { currency: string | null },
>() {
  const isConsignorMasterView = useUserHasConsignorMasterUI();

  return useContextWithSelector(
    isConsignorMasterView
      ? catalogMetricsEmptyContextWithSelector<TMetrics>()
      : catalogMetricsContextWithSelector<TMetrics>()
  );
}
